import { PaginatedFlatListContent } from "@common/screens/PaginatedFlatListContent"
import { apiRequest } from "@data/redux/actions/api"
import { useFocusEffect } from "@react-navigation/native"
import React, { forwardRef, useCallback, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

export const PaginatedFlatList = forwardRef((props, ref) => {
    const {
        data,
        additionalOnRefresh = () => {},
        additionalRefreshing = false,
        requestApiService,
        requestRouteParams,
        requestUrlParams,
        requestData,
        noRefreshWhenNoResults = false,
        stickyHeader = false,
    } = props

    const [currentPage, setCurrentPage] = useState(1)
    const [lastPage, setLastPage] = useState(0)
    const [totalCount, setTotalCount] = useState(-1)

    const resetCounters = () => {
        setCurrentPage(1)
        setLastPage(0)
    }

    const request =
        useSelector((state) => state.api[requestApiService?.name]?.request) ??
        false

    const refreshing = additionalRefreshing || request

    const dispatch = useDispatch()

    const refresh = () => {
        dispatch(
            apiRequest(
                requestApiService,
                requestRouteParams ?? {},
                requestData ?? {},
                {
                    ...requestUrlParams,
                    page: 1,
                }
            )
        )
        additionalOnRefresh()
        resetCounters()
    }

    useFocusEffect(
        useCallback(() => {
            if (
                !refreshing &&
                totalCount > 0 &&
                data?.length === 0 &&
                !noRefreshWhenNoResults
            ) {
                refresh()
            }
            return () => {}
        }, [data])
    )

    return (
        <PaginatedFlatListContent
            {...props}
            totalCount={totalCount}
            setTotalCount={setTotalCount}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            lastPage={lastPage}
            setLastPage={setLastPage}
            refresh={refresh}
            refreshing={refreshing}
            stickyHeader={stickyHeader}
        />
    )
})
